// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.segment-input {
    order: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
}

span.segment-input-label {
    font-size: 85%;
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./qwc2/components/style/SegmentInput.css"],"names":[],"mappings":"AAAA;IACI,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB","sourcesContent":["div.segment-input {\n    order: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\nspan.segment-input-label {\n    font-size: 85%;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
